import React from 'react';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Notification,
  Message,
  IconWithText,
  FormikInput
} from '../../web.common';
import { sentenceCase } from 'change-case';
import CreatableArea from '../misc/CreatableArea';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import { getApiErrorMessage } from '../../common/utils';
import withApi from '../higherOrderComponents/withApi';
import { Divider, DetailsRightBar, NoLink } from './DetailsRightBar';

class ProductGroupInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };

    this.saveEditedProductGroup = this.saveEditedProductGroup.bind(this);
    this.isProductGroupPublic = this.isProductGroupPublic.bind(this);
  }

  async onValidationError({ validateForm }) {
    const validationErrors = await validateForm();
    const fieldsWithError = Object.keys(validationErrors).map(x => sentenceCase(x)).join(', ');
    this.setState({
      apiResponse: new Message('error', `Unable to save. Check fields: ${fieldsWithError}`)
    });
  }

  saveEditedProductGroup(receivedProps) {
    this.setState({ isLoading: true }, async () => {
      const {
        props: {
          language,
          history,
          api: {
            productGroups: {
              create
            }
          }
        }
      } = this;

      let updatedProductGroupData = null;
      let apiResponse;

      try {
        updatedProductGroupData = await create(receivedProps.values);
        apiResponse = new Message('success', 'ProductGroup updated successfully');
      }
      catch (error) {
        apiResponse = getApiErrorMessage(error, language);

        this.setState({
          isLoading: false,
          apiResponse
        });

        return;
      }

      const { Id: productGroupId } = updatedProductGroupData;
      history.push(`/productGroup/${productGroupId}`);
    });
  }

  isProductGroupPublic(isPublic) {
    return (
      <IconWithText
        iconName={isPublic ? 'check' : 'times'}
        iconClasses={[`text-color-${isPublic ? 'success' : 'danger'}`]}
        text='ProductGroup is public'
      />
    );
  }

  render() {
    const { isLoading, apiResponse } = this.state;

    const Id = 0;
    const Name = '';
    const Summary = '';
    const Description = '';
    const CreatedAt = '';

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={apiResponse} />
            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Product Group page'
                documentDescription='Product Group page'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Product Group
              </h2>
              <h5 className='main-page-subheader'><i>New Product Group</i></h5>
              <br />

              <CreatableArea
                ariaEditorName='editor-name'
                onSubmit={receivedProps => this.saveEditedProductGroup(receivedProps)}
                isLoading={isLoading}
                savingText='Updating...'
                displayButtonLabels
                onValidationError={formikProps => this.onValidationError(formikProps)}
                validationSchema={Yup.object().shape({
                  Name: Yup.string()
                    .trim()
                    .min(2, 'Should be at least 2 characters long')
                    .max(256, 'Should be less than 256 characters long')
                    .required('Required'),
                  Description: Yup.string()
                    .trim()
                    .min(2, 'Should be at least 2 characters long')
                    .max(256, 'Should be less than 256 characters long')
                    .required('Required'),
                  Summary: Yup.string()
                    .trim()
                    .min(2, 'Should be at least 2 characters long')
                    .max(256, 'Should be less than 256 characters long')
                    .required('Required')
                })}
                initialValues={{
                  Id,
                  Name,
                  Summary,
                  Description,
                  CreatedAt
                }}
              >
                <React.Fragment>
                  <DataDefinitionList
                    classNames={['border-0', 'detail-page-list']}
                    listData={[{
                      'Name*': <FormikInput name='Name' description='Name' placeholder required />,
                      'Description*': <FormikInput
                        type='textarea'
                        name='Description'
                        description='Description'
                        placeholder
                      />,
                      'Summary*': <FormikInput
                        type='textarea'
                        name='Summary'
                        description='Summary'
                        placeholder
                      />
                    }]}
                    hasWideDescriptions
                  />
                </React.Fragment>
              </CreatableArea>
              <DetailsRightBar>
                <Divider>Links</Divider>
                <NoLink>None</NoLink>
                <Divider>Actions</Divider>
                <NoLink>None</NoLink>
              </DetailsRightBar>
            </div>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}
const ProductGroupAdd = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(ProductGroupInternal)
));

ProductGroupAdd.requiresLogin = true;
ProductGroupAdd.propTypes = { isLoggedIn: PropTypes.bool };

export default ProductGroupAdd;